import { render, staticRenderFns } from "./ClimbRateFields.vue?vue&type=template&id=534e4361&"
import script from "./ClimbRateFields.vue?vue&type=script&lang=ts&"
export * from "./ClimbRateFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClimbRateFields.vue"
export default component.exports